module.exports = __webpack_public_path__ + "static/media/support5.418108d9.png";